import './startup'

import {createApp} from 'vue'
import mitt from 'mitt'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import GlobalComponents from '@/components/global'
import BeetAPI from '@boite-beet/api-client'
import langRouter from '@/extensions/langRouter'
import reveal from '@/extensions/reveal'
import scroll from '@/extensions/scroll'
import Recaptcha from '@/extensions/Recaptcha'

import '@/styles/app.scss'
import VueGtag from 'vue-gtag'

const app = createApp(App)
    .use(i18n)
    .use(store)
    .use(router)
    .use(langRouter, 'fr')
    .use(GlobalComponents)
    .use(reveal)
    .use(BeetAPI, {store, apiUrl: process.env.VUE_APP_API_URL})
    .use(scroll, {
        class: 'v-scroll-reveal',
        duration: 800,
        scale: 1,
        distance: '10px',
        mobile: false
    })
    .use(Recaptcha)

const emitter = mitt()
app.provide('emitter', emitter)

const gtagId = process.env.VUE_APP_GTAG_ID
const gtmId = process.env.VUE_APP_GTM_ID

if (gtagId || gtmId) {
    const options = {
        bootstrap: false,
        config: {id: gtmId ?? gtagId},
    }

    if (gtmId && gtagId) {
        options.includes = [
            {id: gtagId}
        ]
    }

    app.use(VueGtag, options, router)
}

app.mount('#app')
